var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    attrs: {
      placeholder: "Selecciona una o mas palabras existentes",
      options: _vm.descriptors,
      multiple: "",
      value: _vm.value
    },
    on: { input: _vm.onInput }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }